import * as React from 'react';

const AuthenticityDiamond32 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 32 32", width: 32, height: 32, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#F1EAE1",
    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#007782",
    d: "M20.47 10.01h-8.63a1.003 1.003 0 0 0-.71.32l-3.71 4a1 1 0 0 0 0 1.38l8 8a1 1 0 0 0 1.38 0l8-8a1 1 0 0 0 0-1.38l-3.7-4a1 1 0 0 0-.63-.32Z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#fff",
    d: "m19.92 14.31 1.93.38a.38.38 0 0 1 0 .75l-1.93.38-.39 1.94a.38.38 0 0 1-.74 0l-.39-1.94-1.94-.38a.38.38 0 0 1 0-.75l1.94-.38.39-1.94a.38.38 0 0 1 .74 0l.39 1.94Z"
  }
));
AuthenticityDiamond32.Size = 32;
AuthenticityDiamond32.Title = "AuthenticityDiamond";

export { AuthenticityDiamond32 as default };
